import React from "react"
import { useTranslation } from "react-i18next"

import { isMac } from "shared/lib/browser/detectBrowser"

interface RowMenuTooltipContentProps {
  isFocused: boolean
}

export function RowMenuTooltipContent({
  isFocused
}: RowMenuTooltipContentProps) {
  const { t } = useTranslation()
  const shortcut = isMac ? "⌥↓" : "Alt+↓"

  if (!isFocused) return null

  return (
    <div className="tab-bar__tooltip-shortcut-hint">
      {t("TabBar.KeyboardHint", { shortcut })}
    </div>
  )
}
